import React from "react";
import { Box } from "@mui/material";
import { cmToFeetInchesObject, GenerateHeightOptions, MAX_HT_CM, MIN_HT_CM } from "../../constants/profileData";
import SelectInput from "../SelectInput";

const HeightFilter = ({ filterState, setFilterState, isMobile }) => {
    // Generate height options separately for min and max
    var currentMinHeightCm = filterState.heightFilterState[0], currentMaxHeightCm = filterState.heightFilterState[1];
    const minHeightOptions = GenerateHeightOptions(MIN_HT_CM, currentMaxHeightCm-2.54);
    const maxHeightOptions = GenerateHeightOptions(currentMinHeightCm+2.54, MAX_HT_CM);
    const currentMinFtInch = cmToFeetInchesObject(currentMinHeightCm);
    const currentMaxFtInch = cmToFeetInchesObject(currentMaxHeightCm);
    return (
		<Box 
			display="flex" 
			flexDirection="column" 
			gap={isMobile ? 3 : 2} // Increase gap for better spacing on mobile
			alignItems="flex-start"
			p={isMobile ? 1 : 2} // Adjust padding for mobile
			width="100%"
		>
			{/* Min Height Selection */}
			<Box fontWeight="bold" fontSize="14px">Minimum Height</Box>
			<Box 
				display="flex" 
				gap={isMobile ? 1 : 2} // Reduce gap on mobile
				alignItems="center"
				width="100%"
				flexDirection={isMobile ? "column" : "row"} // Stack elements in mobile view
			>
				<SelectInput
					fullWidth={isMobile}					
					name="minHeightFt"
					label="Min Height (ft)"
					value={currentMinFtInch.feet.toString()}
					handleChange={(event) => {
						const value = Number(event.target.value);
						// Change is being used to compute new value. in retrospect we could have just used older value of inches.
						// We are also doing additional validation so user does not go beyond bounds and minHt is always less than maxHt
                        var delta = (value - currentMinFtInch.feet)*30.48;
                        var newHeight = currentMinHeightCm + delta;
                        newHeight = Math.max(
                            MIN_HT_CM, 
                            Math.min(newHeight, currentMaxHeightCm-2.54)
                        );
						setFilterState({
							...filterState,
							heightFilterState: [newHeight, currentMaxHeightCm],
						});
					}}
					options={Object.keys(minHeightOptions).map((ft) => ({ value: ft, label: `${ft} ft` }))}
				/>
				<SelectInput
					fullWidth={isMobile}
					name="minHeightIn"
					label="Min Height (in)"
					value={currentMinFtInch.inches.toString()}
					handleChange={(event) => {
						const value = Number(event.target.value);
                        var delta = (value - currentMinFtInch.inches)*2.54;
                        var newHeight = currentMinHeightCm + delta;
                        newHeight = Math.max(
                            MIN_HT_CM, 
                            Math.min(newHeight, currentMaxHeightCm-2.54)
                        );

						setFilterState({
							...filterState,
							heightFilterState: [newHeight, currentMaxHeightCm],
						});
					}}
					options={minHeightOptions[currentMinFtInch.feet]?.map((inch) => ({ value: inch, label: `${inch} in` })) ?? []}
				/>
			</Box>

			{/* Max Height Selection */}
			<Box fontWeight="bold" fontSize="14px" mt={2}>Maximum Height</Box>
			<Box 
				display="flex" 
				gap={isMobile ? 1 : 2} // Reduce gap on mobile
				alignItems="center"
				width="100%"
				flexDirection={isMobile ? "column" : "row"} // Stack elements in mobile view
			>
				<SelectInput
					fullWidth={isMobile}
					name="maxHeightFt"
					label="Max Height (ft)"
					value={currentMaxFtInch.feet.toString()}
					handleChange={(event) => {
						const value = Number(event.target.value);
                        var delta = (value - currentMaxFtInch.feet)*30.48;
                        var newHeight = currentMaxHeightCm + delta;
                        newHeight = Math.min(
                            MAX_HT_CM, 
                            Math.max(newHeight, currentMinHeightCm +2.54)
                        );
						setFilterState({
							...filterState,
							heightFilterState: [filterState.heightFilterState[0], newHeight],
						});
					}}
					options={Object.keys(maxHeightOptions).map((ft) => ({ value: ft, label: `${ft} ft` }))}
				/>
				<SelectInput
					fullWidth={isMobile}
					name="maxHeightIn"
					label="Max Height (in)"
					value={currentMaxFtInch.inches.toString()}
					handleChange={(event) => {
						const value = Number(event.target.value);
                        var delta = (value - currentMaxFtInch.inches)*2.54;
                        var newHeight = currentMaxHeightCm + delta;
                        newHeight = Math.min(
                            MAX_HT_CM, 
                            Math.max(newHeight, currentMinHeightCm +2.54)
                        );
						setFilterState({
							...filterState,
							heightFilterState: [filterState.heightFilterState[0], newHeight],
						});
					}}
					options={maxHeightOptions[currentMaxFtInch.feet]?.map((inch) => ({ value: inch, label: `${inch} in` }))?? []}
				/>
			</Box>
		</Box>
	);
};

export default HeightFilter;
